import "@carbon/charts/styles.css";
import { SimpleBarChart, GroupedBarChart, StackedBarChart, PieChart, DonutChart, LineChart, ScatterChart } from "@carbon/charts-react";
import { addHeightToOptions // Bar
, groupedBarOptions, groupedBarData, groupedHorizontalBarOptions, groupedHorizontalBarData, simpleBarOptions, simpleBarData, simpleHorizontalBarOptions, simpleHorizontalBarData, simpleBarTimeSeriesOptions, simpleBarTimeSeriesData, simpleHorizontalBarTimeSeriesOptions, simpleHorizontalBarTimeSeriesData, stackedBarOptions, stackedBarData, stackedHorizontalBarOptions, stackedHorizontalBarData, stackedBarTimeSeriesOptions, stackedBarTimeSeriesData, stackedHorizontalBarTimeSeriesOptions, stackedHorizontalBarTimeSeriesData // Pie & donut
, pieOptions, pieData, donutOptions, donutData // Line
, lineTimeSeriesOptions, lineTimeSeriesData, lineData, lineOptions // Step
, stepOptions, stepData, stepTimeSeriesOptions, stepTimeSeriesData // Scatter
, scatterTimeSeriesOptions, scatterTimeSeriesData, scatterOptions, scatterData } from "../../../../src/data/charts/index";
import React from 'react';
export default {
  SimpleBarChart,
  GroupedBarChart,
  StackedBarChart,
  PieChart,
  DonutChart,
  LineChart,
  ScatterChart,
  addHeightToOptions,
  groupedBarOptions,
  groupedBarData,
  groupedHorizontalBarOptions,
  groupedHorizontalBarData,
  simpleBarOptions,
  simpleBarData,
  simpleHorizontalBarOptions,
  simpleHorizontalBarData,
  simpleBarTimeSeriesOptions,
  simpleBarTimeSeriesData,
  simpleHorizontalBarTimeSeriesOptions,
  simpleHorizontalBarTimeSeriesData,
  stackedBarOptions,
  stackedBarData,
  stackedHorizontalBarOptions,
  stackedHorizontalBarData,
  stackedBarTimeSeriesOptions,
  stackedBarTimeSeriesData,
  stackedHorizontalBarTimeSeriesOptions,
  stackedHorizontalBarTimeSeriesData,
  pieOptions,
  pieData,
  donutOptions,
  donutData,
  lineTimeSeriesOptions,
  lineTimeSeriesData,
  lineData,
  lineOptions,
  stepOptions,
  stepData,
  stepTimeSeriesOptions,
  stepTimeSeriesData,
  scatterTimeSeriesOptions,
  scatterTimeSeriesData,
  scatterOptions,
  scatterData,
  React
};